import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import UserSettings from './UserSettings/UserSettings'
import ClientSupport from './ClientSupport/ClientSupport'

import './Header.sass'

const Header = ({ back = false }: { back?: boolean }) => {
  const history = useHistory()
  const loc = useLocation<{ useBack: boolean }>()

  const handleBack = (e) => {
    e.preventDefault()
    if (loc.state?.useBack) {
      history.go(-1)
    } else {
      history.push('/')
    }
  }

  return (
    <header id="masthead">
      <div className="container">
        <section className="side side-left">
          {back &&
            <a className="button" href="/" onClick={handleBack}>
              <span className="icon icon-angle_left" />
              <span><FormattedMessage id="back" /></span>
            </a>
          }
        </section>
        <section className="side side-center">
          <Link to="/" className="logo" />
        </section>
        <section className="side side-right">
          <ClientSupport />
          <UserSettings />
        </section>
      </div>
    </header>
  )
}

export default Header
